/**
 * Supabase browser client — reads url/anon key from either:
 *  1. env vars set at build time (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY), or
 *  2. runtime `/api/config` payload (see AppConfigContext) — this lets ops swap
 *     Supabase projects without a frontend redeploy.
 *
 * When creds are missing/placeholder we export `null` and callers must guard
 * against it (the AuthContext and Login page do exactly this).
 */
import { createClient } from '@supabase/supabase-js';

const PLACEHOLDER = /^your[_-]supabase/i;

function envUrl() {
    const v = (process.env.REACT_APP_SUPABASE_URL || '').trim();
    if (!v || PLACEHOLDER.test(v)) return '';
    return v;
}
function envKey() {
    const v = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();
    if (!v || PLACEHOLDER.test(v)) return '';
    return v;
}

let _client = null;
let _boundUrl = '';
let _boundKey = '';

export function getSupabase({ url, anonKey } = {}) {
    const finalUrl = (url && !PLACEHOLDER.test(url) && url) || envUrl();
    const finalKey = (anonKey && !PLACEHOLDER.test(anonKey) && anonKey) || envKey();
    if (!finalUrl || !finalKey) return null;
    if (_client && _boundUrl === finalUrl && _boundKey === finalKey) return _client;
    _client = createClient(finalUrl, finalKey, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
            storageKey: 'magnidrop-supabase-auth',
        },
    });
    _boundUrl = finalUrl;
    _boundKey = finalKey;
    return _client;
}

export function supabaseConfiguredStatic() {
    return Boolean(envUrl() && envKey());
}
